module.exports = __webpack_public_path__ + "static/media/pt.2488d1f0.svg";